import {
  createTheme,
  darken,
  StyledEngineProvider,
  ThemeProvider,
} from '@mui/material';
import React from 'react';
import { themeModeEnum } from '../../recoil/atoms/themeModeAtom';
/* eslint-disable */
declare module '@mui/material/styles' {
  interface Theme {
    custom: {
      button: {
        delete: {
          main: string;
          dark: string;
          light: string;
          contrastText: string;
        };
        deleteScheduled: {
          main: string;
          dark: string;
          light: string;
          contrastText: string;
        };
      };
    };
  }
  interface ThemeOptions {
    custom?: {
      button?: {
        delete?: {
          main?: string;
          dark?: string;
          light?: string;
          contrastText?: string;
        };
        deleteScheduled?: {
          main?: string;
          dark?: string;
          light?: string;
          contrastText?: string;
        };
      };
    };
  }
}
/* eslint-enable */
const theme = (themeMode: string) =>
  createTheme({
    typography: {
      fontFamily: 'Open Sans',
      fontSize: 13,
    },
    palette: {
      mode: themeMode === themeModeEnum.DARK_MODE ? 'dark' : 'light',
      primary: {
        main: '#0098C7',
        contrastText: '#fff',
      },
      secondary: {
        main: '#DAEFF8',
        contrastText: '#0098C7',
      },
    },
    components: {
      MuiButtonBase: {
        defaultProps: {
          disableRipple: false,
        },
      },
      // MuiPopover: { // This breaks the MUI Select width
      //   defaultProps: {
      //     elevation: 1,
      //   },
      // },
      MuiBackdrop: {
        styleOverrides: {
          root: {
            backgroundColor: 'rgba(0, 0, 0, 0.25)',
          },
        },
      },
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            fontSize: 12,
          },
        },
      },
    },
    custom: {
      button: {
        delete: {
          main: darken(
            '#e31744',
            themeMode === themeModeEnum.DARK_MODE ? 0.1 : 0
          ),
          dark: darken(
            '#e31744',
            themeMode === themeModeEnum.DARK_MODE ? 0.1 : 0.25
          ),
          contrastText: '#fff',
        },
        deleteScheduled: {
          main: darken(
            '#e31744',
            themeMode === themeModeEnum.DARK_MODE ? 0.1 : 0
          ),
          dark: darken(
            '#e31744',
            themeMode === themeModeEnum.DARK_MODE ? 0.1 : 0.25
          ),
          contrastText: '#fff',
        },
      },
    },
  });

interface MaterialThemeProviderProps {
  themeMode: string;
  children: React.ReactNode;
}

export function MaterialThemeProvider({
  themeMode,
  children,
}: MaterialThemeProviderProps) {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme(themeMode)}>{children}</ThemeProvider>
    </StyledEngineProvider>
  );
}
